export const dark = {
  key: 'dark',
  primaryTextColor: '#FFF',
  secondaryTextColor: '#CCC',
  tertiaryTextColor: '#999',
  background: '#000',
  shadowColor: 'rgba(0, 0, 0, 0.5)',
};

export const light = {
  key: 'light',
  primaryTextColor: '#000',
  secondaryTextColor: '#333',
  tertiaryTextColor: '#777',
  background: '#FFF',
  shadowColor: 'rgba(255, 255, 255, 0.5)',
};
